module.exports = __webpack_public_path__ + "static/media/allocationsActive.329d02a3.svg";